import React, { Component } from 'react'
import { compose } from 'redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Row, Col, Card, CardBody, Button, UncontrolledTooltip, Collapse } from 'reactstrap'
import ReactTable from 'react-table'
import _ from 'lodash'

import SearchForm from 'components/searchForm'
import Pagination from 'components/Pagination'
import PageTitle from 'components/Title/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import ConfirmationModal from 'components/Modal/confirmation'
import AnnouncementForm from './Form'
import sessionQueryHandler from 'utils/sessionQueryHandler'

import AnnouncementsHOC from './actions'

class Announcements extends Component {

  componentDidUpdate = pp => {
    const { current_selected_session_id } = this.props.data.SessionReducer
    
    if ( pp.currentPermission !== this.props.currentPermission && this.props.currentPermission.is_read ){
      this.props.getAnnouncements( btoa( JSON.stringify( sessionQueryHandler( { "page": 1 }, current_selected_session_id, 'session_id' ))) )
    }

    if ( pp.data.SessionReducer.current_selected_session_id !== current_selected_session_id 
      && current_selected_session_id 
    ) {
      this.props.getAnnouncements( btoa( JSON.stringify(sessionQueryHandler( { "page": 1 }, current_selected_session_id, 'session_id' ))) )
    }
  }

  render = () => {
    const { is_create, is_delete, is_update } = this.props.currentPermission

    return (
      <>
        <PageTitle
          heading="Announcements"
          subheading="Listings of all the announcements present in the system."
          icon="pe-7s-speaker icon-gradient bg-happy-itmeo"
          buttons={[
            {
              color: 'warning',
              className: 'btn-icon mr-2',
              onClick: () => {
                this.props.onChangeAnnouncementsHOC( 'showSearchForms', !this.props.showSearchForms )
              },
              content:<>
                <i className="pe-7s-search btn-icon-wrapper"> </i>
                <span>Search</span>
              </>
            },
            ... (
              is_create ? [{
                color: 'primary',
                onClick: () => {
                  this.props.onChangeAnnouncementsHOC( 'showCreateAnnouncementsModal', true )
                },
                content: 'Create'
              }] : []
            )
          ]} />
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Collapse
            isOpen={ this.props.showSearchForms }
            onExiting={ () => this.props.onChangeAnnouncementsHOC( 'showSearchForms', false )}
          >
            <SearchForm
              searchParams={ this.props.searchParams }
              onChangeHOCState={ this.props.onChangeAnnouncementsHOC }
              getListAPI={ val => {
                let tempJSON = JSON.parse( atob( val ))
                tempJSON = sessionQueryHandler( tempJSON, this.props.data.SessionReducer.current_selected_session_id, 'session_id' )

                this.props.getAnnouncements( btoa( JSON.stringify( tempJSON )) )
              }}
            />
          </Collapse>
          <Row>
            <Col md={12}>
              <Card className="main-card mb-3">
                <CardBody>
                  <ReactTable
                    pageSize={ 
                      this.props.announcements.data.length < 1? 3: 
                      this.props.announcements.data.length < 10? this.props.announcements.data.length:
                      10
                    }
                    data={ this.props.announcements.data }
                    columns={[
                      {
                        Header: 'Title',
                        accessor: 'title'
                      },
                      {
                        Header: 'Type',
                        accessor: 'type'
                      },
                      {
                        Header: 'Actions',
                        Cell: (row) => {
                          return (
                            <>
                              <Button
                                id="UpdateAnnouncement"
                                disabled={ !is_update }
                                className="mr-2 btn-icon btn-icon-only"
                                color={ is_update ? "primary" : 'secondary' } 
                                onClick={() => {
                                  this.props.getSelectedAnnouncement(row.original.id, 'edit')
                                }}>
                                <i className="pe-7s-pen btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip target="UpdateAnnouncement" placement="left">Update the information of this announcement</UncontrolledTooltip>
                              <Button
                                id="DeleteAnnouncement"
                                disabled={ !is_delete }
                                className="mr-2 btn-icon btn-icon-only"
                                color={ is_delete ? "danger" : 'secondary' } 
                                onClick={() => {
                                  this.props.onChangeAnnouncementsHOC( 'showDeleteAnnouncementModal', true )
                                  this.props.onChangeAnnouncementsHOC( 'selectedDeleteAnnouncementId', row.original.id )
                                }}>
                                <i className="pe-7s-close btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip target="DeleteAnnouncement" placement="left">Delete this Announcement</UncontrolledTooltip>
                            </>
                          )
                        }
                      }
                    ]}
                    showPagination={false} />
                  <Pagination 
                    metadata={ this.props.announcements.meta } 
                    onChangePage={ pg => {
                      const { search } = this.props.data.LastViewReducer.lastView
                      let tempJSON = JSON.parse( atob( search ))
                      tempJSON.page = pg
                      
                      this.props.getAnnouncements( btoa( JSON.stringify( tempJSON )))
                    }} />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <AnnouncementForm
            {...this.props}
            mode={ 'Create' }
            open={ this.props.showCreateAnnouncementsModal }
            onClose={ () => this.props.onChangeAnnouncementsHOC( 'showCreateAnnouncementsModal', false )}
            onClickSubmit={ this.props.createAnnouncement }
          />
          <AnnouncementForm
            {...this.props}
            mode={ 'Edit' }
            selectedFormData={ this.props.selectedAnnouncement }
            open={ this.props.showUpdateAnnouncementsModal }
            onClose={ () => this.props.onChangeAnnouncementsHOC( 'showUpdateAnnouncementsModal', false )}
            onClickSubmit={ this.props.updateAnnouncement }
          />
          <ConfirmationModal
            loading={ this.props.onLoadAnnouncement }
            open={ this.props.showDeleteAnnouncementModal }
            title={ `Delete Announcement` }
            message={ `Are you sure you want to delete this announcement? (This process can't be undone)` }
          
            onClose={ () => this.props.onChangeAnnouncementsHOC( 'showDeleteAnnouncementModal', false )}
            onClickConfirm={ () => this.props.deleteAnnouncement( this.props.selectedDeleteAnnouncementId )}/>
        </ReactCSSTransitionGroup>
        { this.props.onLoadAnnouncement && <LoadingOverlay />}
      </>
    )
  }
}

export default compose(
  AnnouncementsHOC
)(Announcements)